<script>
export default {
  name: "retry",
}
</script>

<template>
  <svg data-v-f170a0fb="" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 21 21"><g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"><path d="M3.578 6.487A8 8 0 1 1 2.5 10.5"></path><path d="M7.5 6.5h-4v-4"></path></g></svg>
</template>
